const STATIC_MAPS_BASE_URL = 'https://maps.googleapis.com/maps/api/staticmap';
const SATELLITE_SIZE = '640x640';
const SATELLITE_SCALE = 2;
const SATELLITE_MAP_TYPE = 'satellite';

export const SATELLITE_DEFAULT_ZOOM = 21;
export const SATELLITE_IMAGE_NAME = 'Satellite Image';
export const SATELLITE_IMAGE_FILE_NAME = 'Satellite Image.jpg';

export function buildSatelliteImageUrl(
  lat: number,
  lng: number,
  zoom: number = SATELLITE_DEFAULT_ZOOM
): string {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    throw new Error('Google Maps API key is not configured');
  }

  const params = new URLSearchParams({
    center: `${lat},${lng}`,
    zoom: String(zoom),
    size: SATELLITE_SIZE,
    scale: String(SATELLITE_SCALE),
    maptype: SATELLITE_MAP_TYPE,
    key: apiKey
  });

  return `${STATIC_MAPS_BASE_URL}?${params.toString()}`;
}

export async function fetchSatelliteImageAsFile(
  lat: number,
  lng: number,
  fileName: string,
  zoom: number = SATELLITE_DEFAULT_ZOOM
): Promise<File> {
  const url = buildSatelliteImageUrl(lat, lng, zoom);
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch satellite image: ${response.status}`);
  }

  const blob = await response.blob();
  return new File([blob], fileName, { type: blob.type || 'image/jpeg' });
}
